import { DIALOG_SMS } from "../consts";

const mydialog = {  
    open: false,
    id: 0, 
    editable: true
}

export default function smsReducer(state = mydialog, { type, payload }) {
    const actions = {
        [DIALOG_SMS] : () => ({...state, ...payload })
    }

    return actions[type]?.call() || state;
}

export const updateSmsDialog = payload    => ({
    type: DIALOG_SMS,
    payload: payload
});
